/* */
/** For Send Page */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { getPhoneNumbers } = actions;

export default () => {
  const authReducer = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  return useEffect(() => {
    if (authReducer.isLogin) {
      dispatch(getPhoneNumbers());
    }
  }, [authReducer.isLogin]);
};
